var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import { AreYouSurePopUp } from "@irati-web/admin/src/components/AreYouSurePopUp";
import { injectIntl } from "@irati/utils/lang";
var Confirm = /** @class */ (function (_super) {
    __extends(Confirm, _super);
    function Confirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            resolveConfirm: function () { return undefined; },
            rejectConfirm: function () { return undefined; }
        };
        _this.confirmPopup = null;
        /**
         *
         * @notes
         * Purposefully returning the `catch => undefined` to suppress any error, it's not an error to cancel an action
         *
         * @returns {Promise<any>}
         */
        _this.onConfirm = function () {
            if (_this.confirmPopup) {
                _this.confirmPopup.toggle();
                return new Promise(function (resolve, reject) {
                    _this.setState({ resolveConfirm: resolve, rejectConfirm: reject });
                })
                    .then(function () { return _this.props.children.props.onClick(); })
                    .catch(function () { return undefined; });
            }
            /** on ref error, shouldn't get to this unless something goes wrong */
            return Promise.reject().catch(function () { return undefined; });
        };
        return _this;
    }
    Confirm.prototype.render = function () {
        var _this = this;
        var _a = this.props, active = _a.active, children = _a.children, confirmButtonText = _a.confirmButtonText, confirmText = _a.confirmText, formatMessage = _a.formatMessage;
        var _b = this.state, resolveConfirm = _b.resolveConfirm, rejectConfirm = _b.rejectConfirm;
        var idNamespace = id("Confirm", this.props);
        var childrenClone = React.cloneElement(children, {
            onClick: active ? this.onConfirm : children.props.onClick
        });
        return (React.createElement(React.Fragment, null,
            childrenClone,
            React.createElement(AreYouSurePopUp, { id: id("popup", idNamespace), ref: function (ref) {
                    _this.confirmPopup = ref;
                }, onSubmit: resolveConfirm, onCancel: rejectConfirm, text: confirmText || formatMessage({ id: "platform.confirm.defaultText" }), buttonText: confirmButtonText || formatMessage({ id: "platform.confirm.defaultButton" }) })));
    };
    Confirm.defaultProps = {
        active: true
    };
    return Confirm;
}(Component));
export default injectIntl(Confirm);
